module.exports = __webpack_public_path__ + "img/body-bg.3472d6a4.webp";